var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"app-loading-spinner",class:[_vm.done && 'app-loading-spinner--done']},[_c('span',{staticClass:"app-loading-spinner__icon-wrapper"},[_c('font-awesome-icon',{attrs:{"icon":_vm.done ? _setup.DONE_ICON : _vm.icon,"size":"2xl"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }